// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1ywY5","range":"MonthRangeSwitch_range__1-Ld-","disabled":"MonthRangeSwitch_disabled__hJLRR"};